import { useEffect, useState } from 'react';

export const SUGGESTED_PRODUCTS_MAX_COLUMNS = 5;
export const SUGGESTED_PRODUCTS_COLUMN_GAP = 8;

const MIN_COLUMN_WIDTH = 140;
const MIN_COLUMNS = 2;

const getColumnsForWidth = (width: number) => {
  if (!width) {
    return SUGGESTED_PRODUCTS_MAX_COLUMNS;
  }

  const fittingColumns = Math.floor(
    (width + SUGGESTED_PRODUCTS_COLUMN_GAP) / (MIN_COLUMN_WIDTH + SUGGESTED_PRODUCTS_COLUMN_GAP),
  );

  return Math.min(SUGGESTED_PRODUCTS_MAX_COLUMNS, Math.max(MIN_COLUMNS, fittingColumns));
};

const useSuggestedProductsColumns = (element: HTMLElement | null) => {
  const [columns, setColumns] = useState(SUGGESTED_PRODUCTS_MAX_COLUMNS);

  useEffect(() => {
    if (!element) {
      return;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      setColumns(getColumnsForWidth(entries[0]?.contentRect.width ?? 0));
    });

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [element]);

  return columns;
};

export default useSuggestedProductsColumns;
